<app-modal-header (closeModal)="close()" [isDisabled]="isHttpRequestRunning"> </app-modal-header>
<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form col-12 mx-auto">
  <app-modal-body>
    <div class="row">
      <div class="col-12">
        <label for="title" class="form-label">{{ 'PDF' | translate }} {{ 'TITLE' | translate }}</label>
        <input type="text" class="form-control" id="title" formControlName="title" />
        @if (title.touched && title.invalid) {
          <p class="mb-0 text-danger fs-13px mt-2">{{ 'PLEASE_ADD_TITLE' | translate }}</p>
        }
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <label for="file" class="form-label">{{ 'FILE' | translate }}</label>
        <div>
          <small [class.text-muted]="!isBgDarkMode" [class.text-white]="isBgDarkMode">{{
            'PDF_ONLY_MAX_10MB' | translate
          }}</small>
        </div>
        <input
          type="file"
          class="form-control"
          id="file"
          formControlName="file"
          accept="application/pdf"
          (change)="onFileChange($event)"
          #fileInput
        />
        @if (file.touched && file.errors?.['size']) {
          <p class="mb-0 text-danger fs-13px mt-2">{{ 'FILE_SIZE_LESS_THAN_10MB' | translate }}</p>
        } @else if (file.touched && file.errors?.['required']) {
          <p class="mb-0 text-danger fs-13px mt-2">{{ 'FILE_IS_REQUIRED' | translate }}</p>
        }
      </div>
    </div>
  </app-modal-body>

  <app-modal-footer>
    <div class="d-flex justify-content-center w-100 gap-2">
      <button type="submit" class="btn btn-primary rounded-5 fw-medium text-center" [disabled]="isHttpRequestRunning">
        @if (isHttpRequestRunning && activeButton === 'save') {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        } @else {
          {{ 'SAVE' | translate }}
        }
      </button>
      @if (brochure?.pdfid) {
        <button
          type="button"
          [class]="'btn btn-outline-danger rounded-5 fw-medium text-center'"
          (click)="deleteBrochure(brochure?.pdfid!)"
          [disabled]="isHttpRequestRunning"
        >
          @if (isHttpRequestRunning && activeButton === 'remove') {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          } @else {
            {{ 'REMOVE' | translate }}
          }
        </button>
        <button
          type="button"
          class="btn rounded-5 fw-medium text-center"
          [class.btn-outline-dark]="!isBgDarkMode"
          [class.btn-outline-light]="isBgDarkMode"
          (click)="openBrochure(brochure?.url!)"
          [disabled]="isHttpRequestRunning"
        >
          {{ 'VIEW' | translate }}
        </button>
      }
    </div>

    @if (changeLogCompanyBrochures?.changelogs?.company_brochure?.name && brochure?.pdfid) {
      <div class="d-flex justify-content-center w-100">
        <small class="d-block text-center mt-2"
          >{{ 'LAST_EDIT' | translate }}: {{ changeLogCompanyBrochures?.changelogs?.company_brochure?.name }},
          {{ changeLogCompanyBrochures?.changelogs?.company_brochure?.timestamp }}</small
        >
      </div>
    }
    @if (errorMessage) {
      <div class="d-flex justify-content-center w-100">
        <span class="text-danger mt-2">{{ errorMessage | translate }}</span>
      </div>
    }
  </app-modal-footer>
</form>
